import * as Id_bs$SolvuuApi0 from "./id_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Int64_wrap$SolvuuApi0 from "./int64_wrap.bs.js";
import * as Job_image_bs$SolvuuRoot0 from "solvuu-root0/./job_image_bs.bs.js";
import * as Job_command_bs$SolvuuRoot0 from "solvuu-root0/./job_command_bs.bs.js";

function write__1(param) {
  return Atdgen_codec_runtime.Encode.contramap(Int64_wrap$SolvuuApi0.unwrap, Atdgen_codec_runtime.Encode.string, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.map(Int64_wrap$SolvuuApi0.wrap, Atdgen_codec_runtime.Decode.string, param);
}

var write_resources = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.$$float, "cpu", t.cpu),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__1, "mem", t.mem),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__1, "disk", t.disk),
  /* [] */
  0]]]);
});
var read_resources = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    cpu: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("cpu", Atdgen_codec_runtime.Decode.$$float, param);
    }, json),
    mem: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("mem", read__1, param);
    }, json),
    disk: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("disk", read__1, param);
    }, json)
  };
});
var write_prefetch = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x[0] >= 666588832) {
    return Atdgen_codec_runtime.Encode.constr1("Batch_id", Id_bs$SolvuuApi0.write_batch, x[1]);
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Blob_id", Id_bs$SolvuuApi0.write_blob, x[1]);
  }
});
var read_prefetch = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Blob_id",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Blob_id */
      [295523485, x]
    );
  }, Id_bs$SolvuuApi0.read_blob, param);
}]],
/* :: */
[
/* tuple */
["Batch_id",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Batch_id */
      [666588832, x]
    );
  }, Id_bs$SolvuuApi0.read_batch, param);
}]],
/* [] */
0]]);
var write_container = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Job_image_bs$SolvuuRoot0.write_t, "image", t.image),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.bool, "cached", t.cached),
  /* [] */
  0]]);
});
var read_container = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    image: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("image", Job_image_bs$SolvuuRoot0.read_t, param);
    }, json),
    cached: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("cached", Atdgen_codec_runtime.Decode.bool, param);
    }, json)
  };
});
var write_command_spec_script = Atdgen_codec_runtime.Encode.string;
var read_command_spec_script = Atdgen_codec_runtime.Decode.string;
var write_command_spec = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x[0] >= 771170225) {
    return Atdgen_codec_runtime.Encode.constr1("Exec", Job_command_bs$SolvuuRoot0.write_t, x[1]);
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Script", write_command_spec_script, x[1]);
  }
});
var read_command_spec = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Exec",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Exec */
      [771170225, x]
    );
  }, Job_command_bs$SolvuuRoot0.read_t, param);
}]],
/* :: */
[
/* tuple */
["Script",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Script */
      [-67845589, x]
    );
  }, read_command_spec_script, param);
}]],
/* [] */
0]]);

function write__3(param) {
  return Atdgen_codec_runtime.Encode.list(write_prefetch, param);
}

function read__3(param) {
  return Atdgen_codec_runtime.Decode.list(read_prefetch, param);
}

function write__2(param) {
  return Atdgen_codec_runtime.Encode.list(function (param) {
    return Atdgen_codec_runtime.Encode.tuple2(Atdgen_codec_runtime.Encode.string, Atdgen_codec_runtime.Encode.string, param);
  }, param);
}

function read__2(param) {
  return Atdgen_codec_runtime.Decode.list(function (param) {
    return Atdgen_codec_runtime.Decode.tuple2(Atdgen_codec_runtime.Decode.string, Atdgen_codec_runtime.Decode.string, param);
  }, param);
}

var write_command = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write_command_spec, "spec", t.spec),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "env", t.env),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__3, "prefetches", t.prefetches),
  /* [] */
  0]]]);
});
var read_command = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    spec: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("spec", read_command_spec, param);
    }, json),
    env: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("env", read__2, param);
    }, json),
    prefetches: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("prefetches", read__3, param);
    }, json)
  };
});
var write_t = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write_resources, "resources", t.resources),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write_command, "command", t.command),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write_container, "container", t.container),
  /* [] */
  0]]]);
});
var read_t = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    resources: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("resources", read_resources, param);
    }, json),
    command: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("command", read_command, param);
    }, json),
    container: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("container", read_container, param);
    }, json)
  };
});
var read_int64 = read__1;
var write_int64 = write__1;
var read_blob_id = Id_bs$SolvuuApi0.read_blob;
var write_blob_id = Id_bs$SolvuuApi0.write_blob;
var read_batch_id = Id_bs$SolvuuApi0.read_batch;
var write_batch_id = Id_bs$SolvuuApi0.write_batch;
var read_image = Job_image_bs$SolvuuRoot0.read_t;
var write_image = Job_image_bs$SolvuuRoot0.write_t;
var read_command_spec_exec = Job_command_bs$SolvuuRoot0.read_t;
var write_command_spec_exec = Job_command_bs$SolvuuRoot0.write_t;
export { read_int64, write_int64, read_resources, write_resources, read_blob_id, write_blob_id, read_batch_id, write_batch_id, read_prefetch, write_prefetch, read_image, write_image, read_container, write_container, read_command_spec_script, write_command_spec_script, read_command_spec_exec, write_command_spec_exec, read_command_spec, write_command_spec, read_command, write_command, read_t, write_t };
/* write_resources Not a pure module */